import React from 'react';

import { useSearch } from '@/domain/search/hooks';

import { FullScreenFiltersModal } from '../full-screen-filters-modal';
import { SmallScreenFiltersSummary } from '../small-screen-filters-summary';

type Props = {
  showFiltersDialog: boolean;
  onClose: () => void;
  onSave: () => void;
};

export const ResultsHeaderMobileContent: React.FC<Props> = ({ showFiltersDialog, onClose, onSave }) => {
  const { data } = useSearch();
  const body = data?.jobSearchByQuery?.searchQuery.body;
  const maybeFilterCollection = body?.filterCollection;

  return (
    <>
      <SmallScreenFiltersSummary />
      <FullScreenFiltersModal
        searchKeywords={body?.keywords}
        searchLocation={body?.location}
        initialTotal={data?.jobSearchByQuery?.total}
        initialAggregations={data?.jobSearchByQuery?.aggregations ?? {}}
        initialFilterCollection={maybeFilterCollection ? maybeFilterCollection : []}
        show={showFiltersDialog}
        onClose={onClose}
        onSave={onSave}
      />
    </>
  );
};
